import Button from 'components/Shared/Button/Button'
import ManualXMLFileDescription from 'components/Shared/ManualXMLFileDescription/ManualXMLFileDescription'
import useCFDIsXMLUploadContainer from './useCFDIsXMLUploadContainer'

export interface ICFDIsXMLUploadContainerProps {
  files: File[]
  handleCloseDrawer: () => void
}

const CFDIsXMLUploadContainer = ({
  files,
  handleCloseDrawer,
}: ICFDIsXMLUploadContainerProps) => {
  const {
    inputFile,
    filesReceived,
    handleSelectFile,
    handleRemoveFile,
    handleReplaceFileWindow,
    handleUploadFiles,
  } = useCFDIsXMLUploadContainer({ files, handleCloseDrawer })

  return (
    <div className="cfdis-xml-upload-container">
      {filesReceived.length === 0 ? (
        <div>No hay archivos seleccionados</div>
      ) : (
        <>
          <div className="xmls-container-title">
            <span>
              Se subirán {filesReceived.length} archivo
              {filesReceived.length > 1 ? 's' : ''}
            </span>
          </div>

          <div className="xmls-container-files-description">
            {filesReceived.map((element, index) => (
              <ManualXMLFileDescription
                key={`uploaded-xml-${element.name}-${index}`}
                id={index}
                fileName={element.name}
                handleRemove={handleRemoveFile(index)}
                handleReplace={handleReplaceFileWindow(index)}
              />
            ))}
            <input
              type="file"
              id="file"
              accept=".xml"
              ref={inputFile}
              style={{ display: 'none' }}
              onChange={handleSelectFile}
            />
          </div>

          <div className="xmls-container-buttons">
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCloseDrawer}>
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleUploadFiles}>
              Guardar
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default CFDIsXMLUploadContainer
